import Dialog from 'components/Dialog';
import React from 'react';
import {useDispatch} from 'react-redux';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import history from 'redux/history';
import {packId} from 'common/diplomatIdUtil';
import actions from 'features/layout/redux/actions';
import FormikTextField from 'components/inputs/FormikTextField';
import {useTranslation} from 'react-i18next';
import {diplomatObjectSchema} from 'types/diplomat-object';
import {IDiplomatObject} from 'types/DiplomatObject';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {ISftpUser} from 'types/diplomat/sftp/SftpUser';
import {DialogTypes} from 'common/names';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import Formik from 'components/hook-form/Formik';

type Props = {
   open?: boolean;
   data?: ISftpUser;
   onClose: () => void;
};

const CreateSftpUserDialog = ({open = true, data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const onSuccess = (data: ISftpUser) => {
      dispatch(actions.loadTreeNav());
      onClose();
      history.push(`/${packId(data.objectType, data.id)}`);
   };
   const {request} = usePostApi<ISftpUser>(api.sftpUser, {onSuccess, onFailure: onClose});
   const handleSubmit = (values: IDiplomatObject) => {
      request(
         JSON.stringify({
            ...values,
            // overwrite: true,
            folderId: data?.id || null,

            permissions: {
               writeFile: true,
               readFile: true,
               listDirectory: true,
               deleteFile: true,
               createDirectory: true,
               deleteDirectory: true,
            },
            password: null,
            enabled: true,
            sshKey: null,
            sshKeyId: null,
            requirePasswordChange: false,
            ipAddresses: [],
            homeDirectory: '/',
            emailAddress: null,
            restrictToHome: true,
            objectType: DiplomatObjectType.enum.SFTP_USER,
            suspended: false,
         }),
         {
            searchParams: {folderId: data?.id || ''},
         }
      );
   };
   return (
      <Dialog
         maxWidth="sm"
         header={DialogTypes.CreateSftpUser.dialogName}
         open={open}
         close={onClose}
      >
         <Formik
            initialValues={diplomatObjectSchema.cast({
               name: '',
            })}
            onSubmit={handleSubmit}
         >
            <>
               <FormikTextField autoFocus required label={t('New User Name:')} name={'name'} />
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default CreateSftpUserDialog;
